module.exports = __webpack_public_path__ + "static/media/form-background.0f185101.jpg";